<template src="./template.html"></template>

<script>
export default {
  name: "HomeCoreStory",
  data() {
    return {}
  },
  methods: {}
}
</script>